import { ApiPropertyOptional } from '@nestjs/swagger'
import { IsOptional, IsUUID, IsString, IsArray } from 'class-validator'
import { Transform } from 'class-transformer'
import { OffsetPaginationQueryDto } from '@sphere/shared/domain'

/**
 * DTO for competency list filters
 */
export class CompetencyFilterDto extends OffsetPaginationQueryDto {
  @ApiPropertyOptional({
    type: 'string',
    description: 'Filter by subject UUID',
    example: '123e4567-e89b-12d3-a456-426614174000',
  })
  @IsOptional()
  @IsUUID()
  subjectId?: string

  @ApiPropertyOptional({
    type: 'string',
    description: 'Filter by domain',
    example: 'Calculer',
  })
  @IsOptional()
  @IsString()
  domain?: string

  @ApiPropertyOptional({
    type: [String],
    description: 'Filter by states (query: states=ACTIVE&states=DRAFT)',
    example: ['ACTIVE', 'DRAFT', 'PUBLISHED'],
    isArray: true,
  })
  @IsOptional()
  @Transform(({ value }: { value: string | string[] }) =>
    value == null ? undefined : Array.isArray(value) ? value : [value]
  )
  @IsArray()
  @IsString({ each: true })
  states?: string[]

  @ApiPropertyOptional({
    type: 'string',
    description:
      'When set, restrict competencies to the subject of this program version’s program',
    example: '123e4567-e89b-12d3-a456-426614174000',
  })
  @IsOptional()
  @IsUUID()
  programVersionId?: string

}

export class ListCompetenciesQueryDto
  extends CompetencyFilterDto
  implements OffsetPaginationQueryDto {}
